require('./bootstrap.js');

import VueSweetalert2 from 'vue-sweetalert2';

import { swalMethodsMixin } from './mixins/swalMethodsMixin.js';
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';

import { translateMixin } from './mixins/translateMixin.js';

const telInputOptions = {
    defaultCountry: '',
    inputOptions: {
        showDialCode: true,
        styleClasses: 'form-control dm-smart-phone-field'
    },
    dropdownOptions: {
        showSearchBox: true
    }
}

import { screenWidthsMixin } from './mixins/screenWidthsMixin.js';

import { createPinia } from 'pinia'
const pinia = createPinia()

import router from './routes/submission-wizard-routes.js'

import { createApp } from 'vue'
import { setupAnalyticsTracking } from './utilities/setupAnalyticsTracking'
setupAnalyticsTracking(router);

createApp({})
    .use(router)
    .use(pinia)
    .use(VueSweetalert2)
    .use(VueTelInput, telInputOptions)
    .mixin(swalMethodsMixin)
    .mixin(screenWidthsMixin)
    .mixin(translateMixin)
    .component('modal', require('./shared/Modal.vue').default)
    .component('spinner', require('./shared/Spinner.vue').default)
    .component('SwLayout', require('./submission-wizard/layouts/SwLayout.vue').default)
    .component('issues-report-button', require('./components/shared/feedback-forms/issues-modal/IssuesReportButton.vue').default)
    .component('issues-report-modal', require('./components/shared/feedback-forms/issues-modal/IssuesReportModal.vue').default)
    .component('register-author-button', require('./components/landing/auth/RegisterAuthorButtonAndModal.vue').default)
    .component('register-or-login-form', require('./components/landing/auth/forms/RegisterOrLogIn.vue').default)
    .component('select-blueprint-button-popup', require('./components/landing/author/SelectBlueprintButtonPopup.vue').default)
    .component('BooleanString', require('./shared/BooleanString.vue').default)
    .mount('#app')



// Make the CTA "Submit" button sticky on the simple landing page initially, then regular on scroll, etc.
jQuery(document).ready(function ($) {

    var $cta = $('.dm-sign-up-or-log-in-section');

    if ($cta.length === 0) {
        return; // No CTA found, exit
    }

    // Calculate the natural position of the CTA
    var naturalPosition = $cta.offset().top;
    var windowHeight = $(window).height();

    // Only apply sticky behavior if CTA is below the fold
    if (naturalPosition > windowHeight) {
        var isSticky = true;

        // Add sticky class initially
        $cta.addClass('dm-sticky-cta');

        $(window).scroll(function () {
            var scrollPosition = $(window).scrollTop() + $(window).height();

            // Toggle sticky class based on scroll position with threshold
            if (scrollPosition >= naturalPosition + 50) {
                if (isSticky) {
                    $cta.removeClass('dm-sticky-cta');
                    isSticky = false;
                }
            } else {
                if (!isSticky) {
                    $cta.addClass('dm-sticky-cta');
                    isSticky = true;
                }
            }
        });
    }
});